document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-nacarbe-open-details]');
  if (!link) return;
  const id = link.getAttribute('href')?.slice(1);
  const details = id ? document.getElementById(id) : null;
  if (details instanceof HTMLDetailsElement) details.open = true;
});

const nacarbePurchaseMain = document.querySelector('main[data-template="product"]');
if (nacarbePurchaseMain && 'IntersectionObserver' in window) {
  const targets = new Map();
  const updateVisibility = () => document.body.classList.toggle('nacarbe-purchase-controls-visible', Array.from(targets.values()).some(Boolean));
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) targets.set(entry.target, entry.isIntersecting);
    updateVisibility();
  });
  const connect = () => {
    for (const element of targets.keys()) {
      if (!element.isConnected) { observer.unobserve(element); targets.delete(element); }
    }
    for (const element of nacarbePurchaseMain.querySelectorAll('.product-form-buttons')) {
      if (!targets.has(element)) { targets.set(element, false); observer.observe(element); }
    }
    updateVisibility();
  };
  connect();
  new MutationObserver(connect).observe(nacarbePurchaseMain, { childList: true, subtree: true });
}

document.addEventListener('click',event=>{const link=event.target.closest('.nacarbe-gallery-index a');if(!link)return;const gallery=link.closest('media-gallery');if(gallery?.dataset.presentation==='grid'&&window.matchMedia('(min-width:750px)').matches){const grid=document.getElementById(link.hash.slice(1).replace('NacarbeMedia-','NacarbeGridMedia-'));if(grid){event.preventDefault();grid.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});}return;}const anchor=document.getElementById(link.hash.slice(1));const slide=anchor?.closest('slideshow-slide');const slideshow=gallery?.querySelector('slideshow-component');if(slide&&typeof slideshow?.select==='function'){const index=[...slideshow.querySelectorAll('slideshow-slide')].indexOf(slide);event.preventDefault();slideshow.select(index);link.parentElement.querySelectorAll('a').forEach(a=>a.removeAttribute('aria-current'));link.setAttribute('aria-current','true');}});

document.addEventListener('slideshow:select',event=>{const gallery=event.target.closest('media-gallery');if(!gallery)return;gallery.querySelectorAll('.nacarbe-gallery-index a').forEach((link,index)=>{if(index===event.detail.index)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});});
